<template>
  <b-dropdown class="select-language-dropdown" :disabled="(selfIdentity != participantIdentity && !!magicToken) || (selfIdentity == participantIdentity && !magicToken)">
    <template #button-content>
      <div class="select-language-dropdown--content d-flex align-items-center">
        <b-icon-globe scale="1"></b-icon-globe>
        <span class="current-language">
          {{ currentLanguage }}
        </span>
      </div>
    </template>
    <b-dropdown-header>
      <b-form-input v-model="query" placeholder="Search ..."></b-form-input>
    </b-dropdown-header>
    <b-dropdown-item
      v-for="(option, index) in filteredOptions"
      :key="index"
      @click="selectLanguage(option)"
    >
      {{ option.label }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapState, mapActions } from "vuex";
import { recognitionLanguages } from "../constants";

export default {
  name: "SelectLanguage",
  props: {
    selfIdentity: String,
    participantIdentity: String,
    magicToken: Object,
  },
  data() {
    return {
      query: '',
    };
  },
  computed: {
    ...mapState({
      agencyVoiceDialects: state => state.agency.voiceDialects,
      remoteVoiceDialects: state => state.transcription.voiceDialects,
    }),
    ...mapGetters("transcription", ["recognitionLanguages", "selfRecognitionLanguage"]),
    languageOptions() {
      const dialects = this.magicToken ? this.remoteVoiceDialects : this.agencyVoiceDialects;
      return dialects || [];
    },
    filteredOptions() {
      if (this.query) {
        return this.languageOptions.filter(item => item.label.toLowerCase().includes(this.query.toLowerCase()))
      }
      return this.languageOptions;
    },
    currentLanguageCode() {
      if (this.selfIdentity == this.participantIdentity) {
        return this.selfRecognitionLanguage || 'en-US';
      }
      return this.recognitionLanguages[this.participantIdentity] || 'en-US';
    },
    currentLanguage() {
      if (this.languageOptions && this.languageOptions.length > 0) {
        const langOption = this.languageOptions.find(lang => {
          const { code } = lang;
          return code == this.currentLanguageCode
        })

        return langOption ? langOption.label : 'English';
      }
      return 'English';
    },
  },
  methods: {
    selectLanguage(option) {
      const { code } = option;

      this.$emit("change", this.participantIdentity, code);
    },
  },
};
</script>

<style lang="scss">
.select-language-dropdown {
  > button {
    padding: 0 !important;
    background-color: transparent !important;
    border: none !important;

    &::after {
      display: none !important;
    }
  }

  > ul.dropdown-menu {
    max-height: 300px;
    overflow-y: auto;
  }
}
.select-language-dropdown--content {
  font-size: 12px;
  color: white;
  padding: 2px;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);

  .current-language {
    text-decoration: underline;
    margin-left: 2px;
  }
}
</style>